import React, { useState } from 'react';
import { Calculator, BadgeCheck, Briefcase, Signal, GraduationCap, Plane, HeartHandshake, Cpu, Award, ShieldCheck, BoxIcon } from 'lucide-react';
import { Input } from './ui/Input';
import { Label } from './ui/Label';
import { Textarea } from './ui/Textarea';
import { Button } from './ui/Button';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from './ui/Select';
interface Partner {
  name: string;
  icon: BoxIcon;
}
const partners: Partner[] = [{
  name: 'ICMAB',
  icon: Calculator
}, {
  name: 'ACCA',
  icon: BadgeCheck
}, {
  name: 'BIAM',
  icon: Briefcase
}, {
  name: 'banglalink',
  icon: Signal
}, {
  name: 'MACQUARIE University',
  icon: GraduationCap
}, {
  name: 'BAFFA',
  icon: Plane
}, {
  name: 'USAID',
  icon: HeartHandshake
}, {
  name: 'IIT',
  icon: Cpu
}, {
  name: 'ACBSP',
  icon: Award
}, {
  name: 'AACSB',
  icon: ShieldCheck
}];
function Field({
  label,
  required,
  children,
  htmlFor
}: {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  htmlFor?: string;
}) {
  return <div className="space-y-1.5" data-id="element-14">
      <Label htmlFor={htmlFor} className="text-xs font-medium text-slate-700" data-id="element-15">
        {label} {required && <span className="text-slate-500" data-id="element-16">*</span>}
      </Label>
      {children}
    </div>;
}
function EnquiryForm() {
  const [answer, setAnswer] = useState('');
  const isValid = answer.trim() === '9';
  return <form onSubmit={e => e.preventDefault()} className="rounded-xl bg-white p-6 shadow-md ring-1 ring-black/5" data-id="element-17">
      <h2 className="text-lg font-bold text-[#0f2d5c]" data-id="element-18">
        Department/Section Related Enquiry
      </h2>
      <p className="mt-0.5 text-sm text-slate-500" data-id="element-19">Submit your query to us</p>

      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-20">
        <Field label="Name" required htmlFor="name" data-id="element-21">
          <Input id="name" placeholder="Name" data-id="element-22" />
        </Field>
        <Field label="Student ID" htmlFor="sid" data-id="element-23">
          <Input id="sid" placeholder="Student ID" data-id="element-24" />
        </Field>
        <Field label="Phone Number" required htmlFor="phone" data-id="element-25">
          <Input id="phone" placeholder="+8801*********" data-id="element-26" />
        </Field>
        <Field label="Email" required htmlFor="email" data-id="element-27">
          <Input id="email" type="email" placeholder="Email" data-id="element-28" />
        </Field>
        <Field label="Message Subject" required htmlFor="subject" data-id="element-29">
          <Input id="subject" placeholder="Message Subject" data-id="element-30" />
        </Field>
        <Field label="To Help Desk" required data-id="element-31">
          <Select data-id="element-32">
            <SelectTrigger className="w-full" data-id="element-33">
              <SelectValue placeholder="Select" data-id="element-34" />
            </SelectTrigger>
            <SelectContent data-id="element-35">
              <SelectItem value="admissions" data-id="element-36">Admissions</SelectItem>
              <SelectItem value="registrar" data-id="element-37">Registrar</SelectItem>
              <SelectItem value="accounts" data-id="element-38">Accounts</SelectItem>
              <SelectItem value="it" data-id="element-39">IT Support</SelectItem>
              <SelectItem value="library" data-id="element-40">Library</SelectItem>
            </SelectContent>
          </Select>
        </Field>
      </div>

      <div className="mt-4" data-id="element-41">
        <Field label="Your Message" required htmlFor="message" data-id="element-42">
          <Textarea id="message" placeholder="Your Message" rows={4} data-id="element-43" />
        </Field>
      </div>

      <div className="mt-4 space-y-1.5" data-id="element-44">
        <Label htmlFor="captcha" className="text-sm font-semibold text-[#b63a2f]" data-id="element-45">
          CAPTCHA: What is 1 + 8 = ? *
        </Label>
        <Input id="captcha" value={answer} onChange={e => setAnswer(e.target.value)} inputMode="numeric" data-id="element-46" />
      </div>

      <Button type="submit" disabled={!isValid} className="mt-5 w-full text-white" style={{
      backgroundColor: isValid ? '#0f2d5c' : undefined
    }} data-id="element-47">
        Submit
      </Button>
    </form>;
}
function Partnerships() {
  return <div className="lg:pt-4" data-id="element-48">
      <h2 className="text-center text-2xl font-bold text-[#0f2d5c] lg:text-3xl" data-id="element-49">
        Partnerships and Affiliates
      </h2>
      <div className="mt-10 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4" data-id="element-50">
        {partners.map(({
        name,
        icon: Icon
      }) => <div key={name} className="flex h-32 flex-col items-center justify-center gap-3 rounded-xl border border-slate-200 bg-white px-4 text-center text-sm font-semibold text-slate-600 shadow-sm transition-all hover:-translate-y-0.5 hover:border-[#0f2d5c]/30 hover:shadow-md" data-id="element-51">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#0f2d5c]/5" data-id="element-52">
              <Icon className="h-7 w-7 text-[#0f2d5c]" strokeWidth={1.75} data-id="element-53" />
            </span>
            {name}
          </div>)}
      </div>
    </div>;
}
export function EnquirySection() {
  return <section className="px-4 py-16 sm:px-6" data-id="element-54">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-start gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-55">
        <EnquiryForm data-id="element-56" />
        <Partnerships data-id="element-57" />
      </div>
    </section>;
}